(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aphros-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aphros-hero-slider')) {
    customElements.define('aphros-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
        this.rotation = this.dataset.autoplay === 'true' && this.slides.length > 1;
        const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
        this.querySelector('[data-controls]')?.removeAttribute('hidden');
        listen(this, 'click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-prev')) this.go(this.index - 1, true);
          if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
          if (button.hasAttribute('data-go')) this.go(Number(button.dataset.go), true);
          if (button.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            this.sync();
          }
        });
        listen(this, 'keydown', (event) => {
          if (!event.target.closest('[data-controls]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
          }
        });
        listen(this, 'pointerdown', (event) => {
          this.touch = event.pointerType !== 'mouse' && !event.target.closest('a, button')
            ? { x: event.clientX, y: event.clientY } : null;
        });
        listen(this, 'pointerup', (event) => {
          if (!this.touch) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });
        listen(this, 'pointercancel', () => { this.touch = null; });
        listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
        listen(this, 'focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        });
        listen(document, 'visibilitychange', () => this.sync());
        listen(this.motion, 'change', () => { this.paused = this.motion.matches; this.sync(); });
        listen(this.mobile, 'change', () => this.sync());
        listen(document, 'shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0 || !this.contains(event.target)) return;
          this.editorSelected = true;
          this.go(index);
        });
        listen(document, 'shopify:block:deselect', (event) => {
          if (!this.contains(event.target)) return;
          this.editorSelected = false;
          this.sync();
        });
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.go(0);
      }

      go(index, announce = false) {
        if (!this.slides.length) return;
        const next = (index + this.slides.length) % this.slides.length;
        const activeElement = document.activeElement;
        if (this.slides[this.index]?.contains(activeElement) && this.index !== next) {
          this.querySelector('[data-next]')?.focus({ preventScroll: true });
        }
        this.index = next;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== next;
          slide.inert = i !== next;
          slide.setAttribute('aria-hidden', String(i !== next));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
        if (announce) this.querySelector('[data-status]').textContent = this.slides[next].getAttribute('aria-label');
        this.sync();
      }

      sync() {
        const running = !this.motion.matches && this.visible && !document.hidden;
        this.querySelectorAll('video').forEach((video) => {
          const wrapper = video.parentElement;
          const rightViewport = wrapper.classList.contains('aphros-hero__video--mobile')
            ? this.mobile.matches
            : !wrapper.classList.contains('aphros-hero__video--desktop') || !this.mobile.matches;
          const active = this.slides[this.index]?.contains(video);
          if (running && active && rightViewport) {
            video.muted = true;
            video.play()?.catch(() => {});
          } else {
            video.pause();
          }
        });
        const toggle = this.querySelector('[data-pause]');
        if (toggle) {
          toggle.setAttribute('aria-label', this.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.setAttribute('aria-pressed', String(this.paused));
          toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
          toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.rotation || this.paused || !this.visible || document.hidden || this.hovered || this.focused || this.editorSelected) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 7000));
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  if (!customElements.get('aphros-cart-discount')) {
    customElements.define('aphros-cart-discount', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        if (new URL(window.location.href).searchParams.get('aphros_discount_error') === '1') {
          this.closest('details').open = true;
          this.querySelector('[data-discount-message]').textContent = this.dataset.invalid;
        }
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          if (this.busy) return;
          const form = event.currentTarget;
          const input = form.querySelector('[name="discount"]');
          const button = form.querySelector('button');
          const message = form.querySelector('[data-discount-message]');
          const discount = input.value.trim();
          if (!discount) { input.reportValidity(); return; }
          this.busy = true;
          button.disabled = true;
          message.textContent = '';
          try {
            const url = new URL(form.action);
            if (!url.pathname.endsWith('.js')) url.pathname += '.js';
            const response = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount })
            });
            const state = await response.json();
            if (!response.ok || state.errors || state.status >= 400) throw new Error('discount');
            const destination = new URL(form.querySelector('[name="return_to"]').value, window.location.origin);
            if (Array.isArray(state.discount_codes) && (state.discount_codes.length === 0 || state.discount_codes.some(code => !code.applicable))) {
              destination.searchParams.set('aphros_discount_error', '1');
            }
            window.location.assign(destination.href);
          } catch {
            message.textContent = this.dataset.error;
          } finally {
            this.busy = false;
            button.disabled = false;
          }
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
